export default (value) => {
  return value.toDate()
}
